import React from 'react';
import Axios, { AxiosRequestConfig } from 'axios';

import useAuthenticationTokens from '@src/hooks/useAuthenticationTokens';

const useAxiosRequestConfig = (
  extras?: AxiosRequestConfig,
  auth = true
): AxiosRequestConfig => {
  const {
    tokens: { accessToken },
  } = useAuthenticationTokens();
  const cancel = React.useRef(Axios.CancelToken.source());

  React.useEffect(() => () => cancel.current.cancel('Canceling request'), []);

  return React.useMemo(() => {
    if (auth) {
      return {
        ...extras,
        cancelToken: cancel.current.token,
        headers: {
          'X-Auth-Token': accessToken,
        },
      };
    }
    return {
      ...extras,
      cancelToken: cancel.current.token,
    };
  }, [accessToken, auth, extras]);
};

export default useAxiosRequestConfig;
